import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import logo from '../../../assets/felog.png';

export function Head({ description, lang, meta, keywords = [], title }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title ? title : "Home"}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title ? `${title} | ${data.site.siteMetadata.title}` : `${data.site.siteMetadata.title} | ${data.site.siteMetadata.author}`,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:image`,
                content: logo,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: "google-site-verification",
                content: "o402P1kCwteUVT_5s9zR21dD9lTF4ALZNLms22CIMx4"
              }
            ]
              .concat(
                {
                  name: `keywords`,
                  content: [...data.site.siteMetadata.keywords, ...keywords].join(`, `),
                }
              )
              .concat(meta)}
          />
        )
      }}
    />
  )
}

Head.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
}

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        keywords
      }
    }
  }
`
